import loadable from '@loadable/component';

export const ViewUnpublishedEventPageLoadable = loadable(
  () => import('./ViewUnpublishedEventPage'),
  { resolveComponent: (module) => module.ViewUnpublishedEventPage },
);
